// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input_container__3X43L {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  /* Chrome, Safari, Edge, Opera */
  /* Firefox */
}
.input_container__3X43L label {
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
}
.input_container__3X43L input::-webkit-outer-spin-button,
.input_container__3X43L input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.input_container__3X43L input[type=number] {
  -moz-appearance: textfield;
}
.input_container__3X43L .input_inputBox__mjJFf {
  height: 39px;
  display: flex;
  align-items: center;
  border-radius: 12px;
  border: 1px rgb(230, 232, 240) solid;
  padding: 0 5px 0 15px;
}
.input_container__3X43L input {
  width: 100%;
  font-family: Hind;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0em;
  text-align: left;
  outline: none;
}
.input_container__3X43L input::placeholder {
  font-family: Hind;
  font-size: 18px;
  font-weight: 500;
  line-height: 40px;
  letter-spacing: 0em;
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/Components/Input/input.module.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EAWA,gCAAA;EAOA,YAAA;AAfJ;AADI;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAGR;AACI;;EAEI,wBAAA;EACA,SAAA;AACR;AAGI;EACI,0BAAA;AADR;AAII;EAEI,YAAA;EAEA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,oCAAA;EACA,qBAAA;AAJR;AAOI;EACI,WAAA;EAMA,iBAAA;EACA,eAAA;EACA,gBAAA;EAEA,mBAAA;EACA,gBAAA;EAEA,aAAA;AAZR;AAgBQ;EACI,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAdZ","sourcesContent":[".container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n\n    label {\n        font-family: Inter;\n        font-size: 16px;\n        font-weight: 600;\n        line-height: 24px;\n        letter-spacing: 0em;\n        text-align: left;\n    }\n\n    /* Chrome, Safari, Edge, Opera */\n    input::-webkit-outer-spin-button,\n    input::-webkit-inner-spin-button {\n        -webkit-appearance: none;\n        margin: 0;\n    }\n\n    /* Firefox */\n    input[type=number] {\n        -moz-appearance: textfield;\n    }\n\n    .inputBox{\n        // color: black;\n        height: 39px;\n        // padding: 20px;\n        display: flex;\n        align-items: center;\n        border-radius: 12px;\n        border: 1px rgba(230, 232, 240, 1) solid;\n        padding:0 5px 0 15px;\n        \n    }\n    input {\n        width: 100%;\n        // color: black;\n        // // height: 39px;\n        // // border-radius: 12px;\n        // // border: 1px rgba(230, 232, 240, 1) solid;\n        // gap: 10px;\n        font-family: Hind;\n        font-size: 18px;\n        font-weight: 500;\n        // line-height: 40px;\n        letter-spacing: 0em;\n        text-align: left;\n        // padding:  0 10px;\n        outline: none;\n        // background-color: transparent;\n        // // background-color: grey;\n\n        &::placeholder {\n            font-family: Hind;\n            font-size: 18px;\n            font-weight: 500;\n            line-height: 40px;\n            letter-spacing: 0em;\n            text-align: left;\n        }\n        // &:focus {\n        //     outline-color: 1.5px solid #0274BD;\n\n        // }\n\n        // &:hover {\n        //     box-shadow: 1px 1px 1px #0274BD;\n        //     border: 1px solid #0274BD;\n        // }\n    }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `input_container__3X43L`,
	"inputBox": `input_inputBox__mjJFf`
};
export default ___CSS_LOADER_EXPORT___;
